import React, { useEffect, useState } from 'react';
import { getCurrentUserOrLogoutRedirect } from '../../auth';
import './user-profile-content.css';

interface IPublicUserProfileContentProps {
	user?: any;
}

const PublicUserProfileContent: React.FC<IPublicUserProfileContentProps> = ({
	user: initialUser,
}) => {
	const [user, setUser] = useState<any | null>(initialUser);

	useEffect(() => {
		const init = async () => {
			if (initialUser) return;

			const user = await getCurrentUserOrLogoutRedirect();
			setUser(user);
		};

		init();
	}, [initialUser]);

	return (
		<div
			className='user-profile-content'
			style={{
				display: 'flex',
				flexDirection: 'column',
				gap: '26px',
				minHeight: '80%',
				height: '100%',
			}}
		>
			<section
				style={{
					display: 'flex',
					gap: '10px',
					flexDirection: 'column',
					marginTop: '10px',
				}}
			>
				<span style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
					<h3
						style={{
							display: 'flex',
							gap: '6px',
							fontWeight: 'normal',
							margin: '0px',
						}}
					>
						Public profile
					</h3>
				</span>
				<div style={{ display: 'flex', gap: '10px', flexDirection: 'column' }}>
					<div>
						<img
							src={user?.picture}
							id='output'
							width='200'
							className='standalone-profile-picture'
							alt='User Profile'
						/>
					</div>
				</div>
			</section>

			<section>
				<span style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
					<h3
						style={{
							display: 'flex',
							gap: '6px',
							fontWeight: 'normal',
							margin: '0px',
						}}
					>
						Security
					</h3>
				</span>
				<div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
					<p
						style={{
							margin: '0px',
							fontSize: '14px',
							marginTop: '6px',
							color: 'rgba(0,0,0,0.54)',
						}}
					>
						{user?.email}
					</p>
				</div>
			</section>
		</div>
	);
};

export default PublicUserProfileContent;
